<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <h2>Persoane juridice</h2>
        <v-text-field label="CUI" v-model="document.cui"> </v-text-field>
        <v-text-field label="J" v-model="document.companyJCode"> </v-text-field>

        <v-text-field label="Administrator" v-model="document.administrator">
        </v-text-field>

        <v-text-field label="Adresa firma" v-model="document.companyAddress">
        </v-text-field>

        <h2>IV. Pretul contractului:</h2>

        <v-text-field
          label="b) Revizie anuala a echipamentului LEI/an cu TVA inclus"
          v-model="document.priceRevision"
          :rules="priceRevisionRules"
          required
        >
        </v-text-field>

        <v-text-field
          label="a) Inlocuire LEI cu TVA inclus"
          v-model="document.priceChange"
        >
        </v-text-field>

        <SignaturePad ref="signatureRef" />

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
          <v-btn @click="preview" color="primary">Previzualizare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import SignaturePad from '@/components/documents/SignaturePad.vue';
import { busEvent } from '../../main';

export default {
  components: {
    SignaturePad,
  },

  data() {
    return {
      valid: true,
      document: {
        type: 'contract',
        cui: '',
        administrator: '',
        priceChange: '',
        priceRevision: '',
        companyJCode: '',
        signature: null,
      },
      priceRevisionRules: [
        (element) => {
          if (!element) return 'Campul trebuie completat';
          return true;
        },
      ],
    };
  },

  async created() {
    // check if we're on edit screen
    if (this.$route.name === 'Editare contract') {
      const document = await this.$store.dispatch('documents/getDocument', {
        clientId: this.$route.params.clientId,
        documentId: this.$route.params.id,
      });

      this.document = {
        ...document.props,
        documentId: document.id
      }
      this.$refs.signatureRef.setSignature(document.props.signature);
    }
  },

  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.document.signature = this.$refs.signatureRef.getSignature();

        if (this.$route.name === 'Editare contract') {
          this.$store
            .dispatch('documents/update', {
              clientId: this.$route.params.clientId,
              body: this.document,
            })
            .then(() => {
              busEvent.$emit('succesPopupCreated', 'Contractul a fost editat');
              this.$router.back();
            });
        } else {
          this.$store
            .dispatch('documents/create', {
              clientId: this.$route.params.clientId,
              body: this.document,
            })
            .then(() => {
              busEvent.$emit('succesPopupCreated', 'Contractul a fost creat');
              this.$router.back();
            });
        }
      }
    },
    async preview() {
      if (this.$refs.form.validate() && this.valid) {
        this.document.signature = this.$refs.signatureRef.getSignature();

        const response = await this.$store.dispatch('documents/preview', {
          clientId: this.$route.params.clientId,
          body: this.document,
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        const fileName =
          response.headers['content-disposition'].match("filename='(.*)'");
        fileLink.setAttribute('download', fileName[1]);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
      }
    },
  },
};
</script>

<style>
</style>
